import { UserGuideScope } from '../../../../../shared/types';
import {
    ALL_USER_GUIDE_CHIPS,
    USER_GUIDE_CHIP_QUERY_PARAM,
    USER_GUIDE_SCOPE_QUERY_PARAM,
} from '../constants';
import { UserGuideChip } from '../types';

export const groupUserGuideScopesByName = (
    items: UserGuideScope[]
): UserGuideChip[] => {
    const groupedByName = new Map<
        string,
        { scopes: Set<string>; weight: number }
    >();

    items.forEach((item) => {
        const existing = groupedByName.get(item.name) || {
            scopes: new Set<string>(),
            weight:
                typeof item.weight === 'number' && Number.isInteger(item.weight)
                    ? item.weight
                    : Number.MAX_SAFE_INTEGER,
        };

        existing.scopes.add(item.scope);

        const itemWeight =
            typeof item.weight === 'number' && Number.isInteger(item.weight)
                ? item.weight
                : Number.MAX_SAFE_INTEGER;

        existing.weight = Math.min(existing.weight, itemWeight);

        groupedByName.set(item.name, existing);
    });

    return Array.from(groupedByName.entries())
        .map(([name, value]) => ({
            name,
            scopes: Array.from(value.scopes).sort((first, second) =>
                first.localeCompare(second)
            ),
            weight: value.weight,
        }))
        .sort((first, second) => {
            if (first.weight !== second.weight) {
                return first.weight - second.weight;
            }

            return first.name.localeCompare(second.name);
        });
};

export const getSelectedChipFromSearch = (
    search: string,
    userGuideScopes: UserGuideScope[] = []
): string => {
    const params = new URLSearchParams(search);
    const chipName = params.get(USER_GUIDE_CHIP_QUERY_PARAM)?.trim();
    const scope = params.get(USER_GUIDE_SCOPE_QUERY_PARAM)?.trim();

    return (
        chipName ||
        (scope
            ? userGuideScopes
                  .find((item) => item.scope.trim() === scope)
                  ?.name.trim()
            : undefined) ||
        ALL_USER_GUIDE_CHIPS
    );
};

export const getSearchWithSelectedChip = (
    search: string,
    selectedChip: string
): string => {
    const params = new URLSearchParams(search);

    if (selectedChip === ALL_USER_GUIDE_CHIPS) {
        params.delete(USER_GUIDE_CHIP_QUERY_PARAM);
    } else {
        params.set(USER_GUIDE_CHIP_QUERY_PARAM, selectedChip);
    }
    params.delete(USER_GUIDE_SCOPE_QUERY_PARAM);

    const nextSearch = params.toString();

    return nextSearch ? `?${nextSearch}` : '';
};
